const routesToTitles = {
  "/employee/dashboard": "Dashboard",
  "/admin/dashboard": "Dashboard",
  "/admin/controls": "Controls",
  "/admin/tasks": "Tasks",
  "/framework": "Framework",
  "/policy-enforsement": "Policy Enforcement",
  "/documents": "Documents",
  "/admin/risks": "Risk Management",
  "/admin/access": "Access Management",
  "/admin/access/:systemId": "System Review",
  "/admin/audits": "Audits",
  "/auditor/audits": "Audits",
  "/admin/integrated-evidences": "Integrated Evidences",
  "/admin/regoai": "Rego AI",
  "/vendors": "Vendors",
  "/admin/vendors": "Vendors",
  "/admin/vendors/:vendorId": "Vendor Details",
  "/vulnerabilities": "Vulnerabilities",
  "/people": "People",
  "/devices": "Devices",
  "/infrastructure": "Infrastructure",
  "/admin/code-security": "Code Security",
  "/infrastructure/overview": "Overview",
  "/infrastructure/overview/:name": "",
  "/audit-logs": "Audit Logs",
  "/integrations": "Integrations",
  "/frameworks": "Frameworks",
  // "/admins": "Admins",
  "/employee/policies": "Policies",
  "/admin/policies": "Policies",
  "/company-profile": "Company Settings",
  "/company-settings": "Company Settings",
  "/frameworks/details:name": "Framework Detail",
  "/policy/detail:name": "Policy",
  "/policy/ack:name": "Policy",
  "/chat": "Rego AI",
  "/integrations": "Integrations",
  "/employee/training": "Training",
  "/training/:name": "Training",
  "/admin/training": "Training",
  "/assets": "Assets",
  "/admin/assets": "Assets",
  "/employee/assets": "Assets",
};

const formatName = (name, matchingRoute) => {
  if (matchingRoute === "/frameworks/details:name") {
    return name
      .split("-")
      .map((word, index) =>
        index === 0
          ? word.toUpperCase()
          : word.charAt(0).toUpperCase() + word.slice(1)
      )
      .join(" ");
  }
  if (matchingRoute === "/infrastructure/overview/:name") {
    return name
      .split("-")
      .map((part, i) =>
        i === 1
          ? part.toUpperCase()
          : part.charAt(0).toUpperCase() + part.slice(1)
      )
      .join(" ");
  } else {
    return name
      .split("-")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
      .join(" ");
  }
};

const getTitleFromPath = (path) => {
  // Sort routes by length in descending order to prioritize specific routes
  const matchingRoute = Object.keys(routesToTitles)
    .sort((a, b) => b.length - a.length)
    .find((route) => path.startsWith(route.replace(":name", "")));

  if (
    matchingRoute === "/policy/detail:name" ||
    matchingRoute === "/frameworks/details:name" ||
    matchingRoute === "/infrastructure/overview/:name"
  ) {
    const name = path.split("/").pop(); // Extract the name from the path
    return ` ${formatName(name, matchingRoute)}`; // Format and append the name
  }

  if (matchingRoute === "/training/:name") {
    const name = path.split("/");
    return ` ${formatName(name[name.length - 2], matchingRoute)}`; // Format and append the name
  }
  return routesToTitles[matchingRoute];
};

const getParentRoute = (path) => {
  if (path.startsWith("/frameworks/details")) return "/frameworks";
  if (path.startsWith("/policy/detail")) return "/admin/policies";
  if (path.startsWith("/policy/ack")) return "/employee/policies";
  // if (path.startsWith("/access/overview")) return "/access";
  if (path)
    if (
      path.startsWith("/infrastructure/overview/") &&
      path.split("/").length === 4
    )
      return "/infrastructure/overview";
  if (path.startsWith("/admin/code-security/")) {
    const parts = path.split("/").filter(Boolean);
    if (parts.length >= 4) return `/admin/code-security/${parts[2]}`;
    return "/admin/code-security";
  }
  if (path.startsWith("/infrastructure/overview")) return "/infrastructure";

  if (path.startsWith("/training/")) {
    const parts = path.split("/").filter(Boolean);
    if (parts.length === 3) {
      //Get moduleId from state or fallback
      const state = window.history.state?.usr || {}; // safe way to get React Router state
      const moduleId = state?.moduleId ?? null;

      const moduleName = parts[1];

      // fallback if no moduleId (avoid broken navigation)
      if (!moduleId) return "/employee/training";

      return `/training/${moduleName}?id=${moduleId}`;
    }
    if (parts.length === 2) {
      return "/employee/training";
    }
  }
  return null;
};

export { getTitleFromPath, getParentRoute };
